import React from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import loadingLogo from '@src/public/assets/images/loadingLogo.gif';
import styles from './index.css';

const Spin = () => (
    <div className={styles.loading}>
        <img src={loadingLogo} alt="" />
    </div>
);

export default errorBoundary(Spin);
